import h from 'hyperscript';

import './routing-legend.css';

import duration
  from '@disy/cadenza-icons/routing-mini-legend-stopwatch.svg';
import distance from '@disy/cadenza-icons/routing-distance.svg';
import polygonFilled from '@disy/cadenza-icons/polygon-filled.svg';

import { icon } from 'cadenza/utils/icon/icon';
import { getIconForProfile, renderAvoidanceCount } from 'cadenza/map/legend/routing-legend-utils';

import i18n from './isochrone-legend.properties';

export function renderIsochroneLegend (layerLegendElement) {
  return [ h('.legend-element', layerLegendElement.entries.map(renderIsochroneEntry)) ];
}

function renderIsochroneEntry (isochroneEntry) {
  return [
    h('.legend-element-entry.isochrone-legend-entry.d-stack-v.space-1',
      [
        renderPoints(isochroneEntry.startingPoints),
        h('.isochrone-legend-entry--header.d-stack-h.space-1', [
          getIconForProfile(isochroneEntry.profile),
          renderDistanceOrDuration(isochroneEntry),
          renderAvoidanceCount(isochroneEntry.avoidanceCount)
        ]),
        ...isochroneEntry.zones.map(renderZone)
      ]
    ),
    h('hr.d-compact-legend--separator')
  ];
}

function renderPoints (startingPoints) {
  if (startingPoints.length === 1) {
    return h('h2.d-compact-legend--layer-heading', `${i18n('point')} ${startingPoints[0]}`);
  } else {
    return h('h2.d-compact-legend--layer-heading', `${i18n('points')} ${startingPoints[0]}-${startingPoints[startingPoints.length - 1]}`);
  }
}

function renderDistanceOrDuration (isochroneEntry) {
  if (isochroneEntry.totalDuration) {
    return h('span.duration', [ icon(duration), h('span', isochroneEntry.totalDuration) ]);
  } else {
    return h('span.distance', [ icon(distance), h('span', isochroneEntry.totalDistance) ]);
  }
}

function renderZone (zone) {
  const zoneIcon = icon(polygonFilled);
  zoneIcon.style.color = zone.color;
  return h('div.isochrone-legend-entry--zone.d-stack-h.space-2', [
    zoneIcon,
    h('span.isochrone-legend-entry--zone-value', zone.value)
  ]);
}
